import {createContext} from 'react'

const UsuariosContext = createContext()

export default UsuariosContext